export function formulaToString(formulaArray: Array<any>, forValidation: boolean) {
    const arr = formulaArray;
    const strArr = arr.filter((elem: any) => elem !== null).map((elem: any, idx: number) => {
        if (elem.type === 'string') {
           return elem.value;
        } else
        if (elem.type === 'element') {
           return forValidation ? 1 : elem.value.key;
        } else
        if (elem.type === 'constant') {
            return forValidation ? 1 : elem.value;
        } else
        if (elem.type === 'count') {
            return forValidation ? 1 : elem.value;
         }
    });
    const formulaStr = strArr.join('');
    return formulaStr;
}
export function getFormulaElementKeys(formulaArray: Array<any>) {
    return formulaArray.filter((elem: any) => elem.type === 'element')
                       .map((elem: any) => elem.value.key);
}
export function formulaValidate(formulaArray: Array<any>) {
    const formulaStr = formulaToString(formulaArray, true);
    const res =  evalFormulaString(formulaStr, undefined);
    // console.log('Formula Eval:', formulaStr, res);
    if (res === undefined ) {
        return false;
    }
    return true;
}
function evalFormulaString(formulaStr: string, rows: Array<any>) {
    formulaStr = formulaPacify(formulaStr);
    // console.log('Formula Eval:', formulaStr);
    try {
        if (formulaStr.indexOf('return') === -1) {
            // tslint:disable-next-line:no-eval
            return eval(formulaStr);
        } else {
            // tslint:disable-next-line:no-eval
            const func = eval('() => {' + formulaStr + '}');
            return func();
        }
    } catch (e) {
       return undefined;
    }
}
export function formulaEvaluateSimple(formulaArray: Array<any>,  row: any, getFormelVals?: boolean) {
    // console.log('formulaArray', formulaArray);
    // console.log(data);
    const arr = formulaArray;
    const strArr = arr.map((elem: any, idx: number) => {
        if (elem.type === 'string') {
           return elem.value;
        } else
        if (elem.type === 'element') {
            const val = row[elem.value.key];
            if ( isNaN(+val)) {
                return 0;
                // return '\'' + val + '\'';
            } else {
                return +val;
            }
        }
    });
    const formulaStr = strArr.join('');
    // console.log('Formula: ', formulaStr);
    const value = evalFormulaString(formulaStr, undefined);
    return (getFormelVals ? formulaStr : value);
}
export function formulaEvaluate(formulaArray: Array<any>, actAtt: any, row: any, rows: Array<any>,
    atts: ReadonlyArray<any>, mode: string, formulaDoneKeys: any, formulaEarlyKeys: any, error: string, counts: any) {
    // console.log(formulaArray);
    // console.log(data);
    let toEarly = false;
    const arr = formulaArray;
    const strArr = arr.map((elem: any, idx: number) => {
        if (elem.type === 'string') {
           return elem.value;
        } else
        if (elem.type === 'count') {
            // console.log('countFound', elem, counts);
            const entity = elem.value.entity;
            return counts[entity];
         } else
        if (elem.type === 'constant') {
            switch (elem.value) {
                case 'UST':
                    return 1.19;
                case 'ROWCOUNT':
                    return rows.length;
            }
        } else
        if (elem.type === 'element') {
            const val = row[elem.value.key];
            const att = atts.find((attCheck: any) => attCheck.KEY === elem.value.key);
            if (!att) {
                console.log('Search', atts, elem.value.key);
            } else
            if (att.TYPE === 'FORMULA') {
                if (val !== undefined) { // War ggf. schon vorher ok
                    formulaDoneKeys[att.KEY] = true;
                }
                if (!error && att.FORMULA_EVAL === 'post' && mode === 'pre') {
                    error = 'Eine Formel-Element mit Verarbeitung vor der Aggregation (' + actAtt.NAME + ') ' +
                            'kann nicht auf ein Element mit der Verarbeitung nach der Aggregation zugreifen (' + att.NAME + ').' +
                            'Bitte korregieren Sie das Problem';
                }
                if (formulaDoneKeys[att.KEY] === true) {
                    // console.log(att.KEY + ' IS ready');
                    delete(formulaEarlyKeys[actAtt.KEY]);
                } else {
                    // console.log(att.KEY + ' is not ready');
                    toEarly = true;
                    formulaEarlyKeys[actAtt.KEY] = true;
                }
                //  console.log('Formula-Elem found: ' + actAtt.KEY + ' -> ' + att.KEY + ' ' + att.FORMULA_EVAL + ' ' + mode);
            }
            if ( isNaN(+val)) {
                return '\'' + val + '\'';
            } else {
                return +val;
            }
        }
    });
    const formulaStr = strArr.join('');
    const value = toEarly ? undefined : evalFormulaString(formulaStr, rows);
    if (!toEarly) {
        formulaDoneKeys[actAtt.KEY] = true;
    }
    return {value,  error};
}
function formulaPacify(formulaStr: string) {     // Böse Kommandos entfernen
    if (!formulaStr) {
     return '';
    }
    formulaStr = formulaStr.replace('alert(', 'console.log(\'Alert Captured: \' + '); // Alerts abfangen
    // console.log('Pacified Formula: ' + formulaStr);
    return formulaStr;
}
export function formulaProcessData(atts: ReadonlyArray<any>, data: Array<any>, mode: string, counts: any) { // mode = pre oder post
    const result: Array<any> = [];
    // console.log('formulaProcess Rows: ' + data.length);
    let error: string = undefined;
    if (!data || !data.forEach) {
        return result;
    }
    data.forEach((row: any) => {
        let keepOnRunning = true;            // Solange true berechnen wir die Zeile immer wieder -----> ACHTUNG: Abbruchbedingungen!
        let earlyCount = -1;
        let runCnt = 0;
        const formulaDoneKeys: any = {};    // Jede Formel (je Zeile) schreibt sich hier rein, wenn Sie fertig ist, also den key
        const formulaEarlyKeys: any = {};    // Jede Formel (je Zeile) schreibt sich hier rein, wenn Sie nicht berechnet werden konnte
        while (keepOnRunning)  {
            runCnt++;
            atts.forEach((att: any) => {
                if (att.TYPE === 'FIX') {
                    row[att.KEY] = att.CONTENT;
                } else
                if (att.TYPE === 'FORMULA' && (mode === 'pre' && !att.FORMULA_EVAL) || (att.FORMULA_EVAL && att.FORMULA_EVAL === mode) ) {
                    // console.log(mode + ' --> ' + att.FORMULA);
                    if (att.FORMULA instanceof Array) {
                        const resEval = formulaEvaluate(att.FORMULA, att, row, data, atts, mode, formulaDoneKeys,
                                                        formulaEarlyKeys, error, counts);
                        row[att.KEY] = resEval.value;
                        if (resEval.error && !error) {
                            error = resEval.error;
                        }
                    } else {
                        // tslint:disable-next-line:no-eval
                        row[att.KEY] = evalFormulaString(att.FORMULA, data);
                    }
                }
            });
            const earlyThisRun = Object.keys(formulaEarlyKeys).length;
            if (earlyThisRun === 0) {   // Wenn es keine Felder gibt, die noch unberechnet sind ! --> FERTIG
                keepOnRunning = false;
            } else {
                // OHA es sind noch nicht alle Felder berechnet
                if (earlyCount === earlyThisRun) {
                    // Es hat sich nichts geändert
                    if (!error) {
                        error = 'Die Verarbeitung konnte nicht vollständig durchgeführt werden, bitte prüfen Sie z.B. Zirkelbezüge! ';
                        error += 'Betroffene Felder: ' + fieldKeysToString(formulaEarlyKeys, atts);
                    }
                    keepOnRunning = false;
                } else {
                    // OK, es wurden im letzten Durchlauf noch Felder berechnet, also weiterlaufen
                    earlyCount = earlyThisRun;
                }
            }

            /* if (mode === 'post') {
                console.log('Done / Early (' + runCnt + ') : ' , formulaDoneKeys, formulaEarlyKeys);
            } */
        }
        result.push(row);
    });
    if (error) {
        alert(error);
    }
    return result;
}

function fieldKeysToString(fieldKeys: any, atts: ReadonlyArray<any>) {
    const arrNames = Object.keys(fieldKeys).map((field: any) => {
        const attFound = atts.find((att: any) => att.KEY === field);
        return attFound.NAME;
    });
    return arrNames.join(', ');
}
